import React, { Component } from 'react'

import { Container, Row, Col } from 'reactstrap'
import CarsList from '../CarsList'
import { debounce, orderBy } from 'lodash'
import '../CarsList.css'
import CarsListHeader from "../CarsListHeader"

const fleetViews = [
    { id: "#fleet", canManageView: false },
    { id: "#manage", canManageView: true }
]

class FleetManagementContainer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            orderBy: ["-id"],
            carManageView: false,
            filterValues: {
            }
        }
    }
    updateSearchTerm = debounce((searchTerm) => {
        this.setState({ searchTerm: searchTerm })
    }, 500)

    updateOrder = (string) => {
        let order = this.state.orderBy ? [...this.state.orderBy] : []
        let index = order.indexOf(string)
        if (index > -1) {
            order[index] = "-" + string
        } else {
            index = order.indexOf("-" + string)
            index > -1 ? order.splice(index, 1) : order.unshift(string)
        }
        this.setState({ orderBy: order })
    };
    componentDidMount() {
        if (window.location.hash && fleetViews.map(item => item.id).includes(window.location.hash)) {
            let tabIndex = fleetViews.findIndex(tab => tab.id === window.location.hash)
            window.location.hash = fleetViews[tabIndex].id
            this.setState({ canManageView: fleetViews[tabIndex].canManageView })
        } else {
            window.location.hash = fleetViews[0].id
            this.setState({ canManageView: fleetViews[0].canManageView })
        }
    }
    updateCarManageView = () => {
        let tabIndex = fleetViews.findIndex(tab => tab.canManageView === !this.state.carManageView)
        window.location.hash = fleetViews[tabIndex].id
        this.setState({ carManageView: !this.state.carManageView })
    }

    render() {
        return (
            <Container fluid className="FleetManagementContainer CarListContainer">
                <CarsListHeader
                    activeTab={this.state.activeTab}
                    filterValues={this.state.filterValues}
                    setFilterValues={(filterValues) => this.setState({ filterValues })}
                    carManageView={this.state.carManageView} location={this.props.location} history={this.props.navigate}
                    updateCarManageView={this.updateCarManageView}
                />
                <Row>
                    <Col sm="12">
                        <CarsList
                            isFleetManagement={true}
                            currentUser={this.props.currentUser}
                            searchTerm={this.state.filterValues && this.state.filterValues.searchTerm ? this.state.filterValues.searchTerm : null}
                            orderBy={this.state.orderBy}
                            updateOrder={this.updateOrder}
                        />
                    </Col>
                </Row>
            </Container>
        )
    }
}

export default FleetManagementContainer
